"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var valueFromText_1 = __importDefault(require("../serialize/valueFromText"));

var getDomSelection_1 = __importDefault(require("../selection/getDomSelection"));

function onPaste(editorState, event) {
  var position = getDomSelection_1.default(editorState.list);

  if (position === null) {
    console.warn('cant get start and end selection');
    return editorState;
  }

  event.preventDefault();
  var start = position.start,
      end = position.end;

  if (event.clipboardData == null) {
    return editorState;
  }

  var text = event.clipboardData.getData('text');
  var value = valueFromText_1.default(text);
  var changed = editorState.change({
    start: start,
    end: end,
    value: value
  }).change({
    start: start + value.length,
    end: start + value.length,
    value: []
  });
  return changed;
}

exports.default = onPaste;